import React from "react";
import { Phone, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-200 bg-white py-14"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo size={44} testId="footer-logo" />
            <p className="mt-4 max-w-sm font-body text-sm font-medium leading-relaxed text-slate-600">
              Professional commercial restroom sanitation. Reliable, detail-oriented, and fully insured.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-body text-xs font-semibold uppercase tracking-widest text-slate-500">
              Contact
            </p>
            <ul className="mt-4 space-y-3 font-body text-sm font-medium text-slate-700">
              <li>
                <a
                  href="tel:9102369971"
                  data-testid="footer-call-link"
                  className="inline-flex items-center gap-2 hover:text-blue-600"
                >
                  <Phone size={14} strokeWidth={1.8} /> 910-236-9971
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@deepcleanrr.com"
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-2 hover:text-blue-600"
                >
                  <Mail size={14} strokeWidth={1.8} /> info@deepcleanrr.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-body text-xs font-semibold uppercase tracking-widest text-slate-500">
              Trust
            </p>
            <p className="mt-4 font-body text-sm font-medium leading-relaxed text-slate-700">
              Professional • Reliable • Fully Insured. Satisfaction guaranteed every visit.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-slate-200 pt-6 md:flex-row md:items-center">
          <p className="font-body text-xs text-slate-500">
            © {new Date().getFullYear()} Deep Clean Restroom Services. All rights reserved.
          </p>
          <p className="font-body text-xs text-slate-500">
            Because clean restrooms matter.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
